import { call, put, select, takeEvery } from 'redux-saga/effects';

import camelcaseKeys from 'camelcase-keys';
import { normalize } from 'normalizr';
import * as actions from '../../../actions/static-catalogs/sensor-brands';
import * as authSelectors from '../../../reducers/auth';
import * as schemas from '../../../schemas/sensor-brands';
import * as types from '../../../types/static-catalogs/sensor-brands';
import API_BASE_URL from '../../settings/apibaseurl';

/* -------------------------------------------------------------------------- */
/*                                 FETCH LIST                                 */
/* -------------------------------------------------------------------------- */
function* fetchSensorBrandsList(action) {
  try {
    const isAuth = yield select(authSelectors.isAuthenticated);
    if (isAuth) {
      const token = yield select(authSelectors.getAuthToken);
      const response = yield call(fetch, `${API_BASE_URL}/sensorBrand/get`, {
        method: 'POST',
        body: JSON.stringify({}),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      });
      const jsonResult = yield response.json();
      if (response.status <= 300 && jsonResult.success) {
        const resultData = jsonResult.data.map((result) => camelcaseKeys(result));
        const {
          entities: { sensorBrands },
          result //order
        } = normalize(resultData, schemas.sensorBrands); //normalize data to byId and order
        yield put(actions.completeFetchingSensorBrands(sensorBrands, result));
      } else {
        const error = {
          errorMessage: jsonResult.message,
          errorNumber: jsonResult.number
        };
        // alerts.showErrorAlertFailChanges({ error });
        yield put(actions.failFetchingSensorBrands(error));
      }
    }
  } catch (err) {
    const error = {
      errorMessage: err.toString(),
      errorNumber: -1
    };
    // alerts.showErrorAlertFailChanges({ error });
    yield put(actions.failFetchingSensorBrands(error));
  }
}

export function* watchFetchSensorBrandsList() {
  yield takeEvery(types.SENSOR_BRANDS_FETCH_STARTED, fetchSensorBrandsList);
}
